module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"day_format":"M月d日"},"en":{"day_format":"MMM d"}}')
  delete Component.options._Ctor
}
